import ko from "knockout";
import $ from "jquery";
import commander, { ICommandResult } from "flow/cli/commander";
import Writer from "flow/cli/Writer";
import register from "flow/knockout/register";

// http://knockoutjs.com/documentation/extenders.html
register.registerKnockoutExtension("prompt", function (target: KnockoutObservable<string>, prompt: string) {
    //create a writeable computed observable to intercept writes to our observable
    const result = ko
        .computed({
            read: target, //always return the original observables value
            write: function (newValue: string) {
                let valueToWrite = newValue;
                const current = target();

                if (newValue) {
                    if (newValue.indexOf(prompt) !== 0) {
                        if (newValue.indexOf(prompt) === -1) {
                            if (newValue.indexOf(prompt.substring(0, prompt.length - 1)) === 0) {
                                valueToWrite = prompt;
                            } else {
                                valueToWrite = prompt + newValue;
                            }
                        } else {
                            valueToWrite = newValue.substring(newValue.indexOf(prompt));
                        }
                    }
                } else {
                    valueToWrite = prompt;
                }

                if (valueToWrite !== current) {
                    target(valueToWrite);
                } else {
                    target.notifySubscribers(valueToWrite);
                }
            }
        })
        .extend({ notify: "always" });

    //initialize with current value to make sure it is rounded appropriately
    result(target());

    //return the new computed observable
    return result;
});

register.registerKnockoutBinding("commander", {
    init: function (element, valueAccessor, _allBindingsAccessor, _viewModel, bindingContext) {
        const dashViewModel = bindingContext.$root;
        const terminalHandle = valueAccessor();

        const prompt = "> ";

        const commandViewModel = {
            commandLineRows: ko.observable(1),
            commandInput: ko.observable().extend({ prompt: prompt })
        };

        const $terminal = $(element).children(".dash-terminal").first();

        const $output = $(element).find(".dash-terminal-output").first();

        const $input = $(element).find(".dash-command-input").first();

        const writer = new Writer($output);

        const observe = function ($textarea: JQuery<HTMLElement>, event: string, handler: (event: any) => void) {
            $textarea.on(event, handler);
        };

        function resize() {
            $input.height("auto");
            const desiredHeight = Math.max($input[0].scrollHeight, 24);
            $input.height(desiredHeight + "px");
        }

        /* 0-timeout to get the already changed text */
        function delayedResize() {
            setTimeout(resize, 0);
        }

        observe($input, "change", resize);
        observe($input, "cut", delayedResize);
        observe($input, "paste", delayedResize);
        observe($input, "drop", delayedResize);
        observe($input, "keydown", delayedResize);

        const processResult = function (result: ICommandResult) {
            commandViewModel.commandInput(result.input);
        };

        let tabHint = false;
        let cmd;

        $input.on("keydown", function (event) {
            if (event.keyCode) {
                const keyCodes = $.ui.keyCode;
                switch (event.keyCode) {
                    case keyCodes.ENTER:
                        cmd = commandViewModel.commandInput();
                        cmd = cmd.substring(prompt.length);

                        $input.hide();

                        commander.execute(writer, prompt, cmd).done(function (result) {
                            $input.show();
                            processResult(result);
                            $input[0].scrollIntoView();
                            $input.focus();
                        });

                        event.preventDefault();
                        break;
                    case keyCodes.TAB:
                        cmd = commandViewModel.commandInput();
                        cmd = cmd.substring(prompt.length);

                        if (tabHint) {
                            processResult(commander.hint(writer, cmd));
                        } else {
                            processResult(commander.complete(cmd));
                            tabHint = true;
                            setTimeout(function () {
                                tabHint = false;
                            }, 300);
                        }

                        event.preventDefault();
                        break;
                    case keyCodes.UP:
                        commandViewModel.commandInput(commander.getPreviousCommand());
                        event.preventDefault();
                        break;
                    case keyCodes.DOWN:
                        commandViewModel.commandInput(commander.getNextCommand());
                        event.preventDefault();
                        break;
                }
            }
        });

        $input.on("keyup", function (event) {
            if (event.keyCode) {
                const keyCodes = $.ui.keyCode;
                switch (event.keyCode) {
                    case keyCodes.ENTER:
                        event.preventDefault();
                        break;
                    case keyCodes.TAB:
                        event.preventDefault();
                        break;
                    case keyCodes.ESCAPE:
                        dashViewModel.hide();
                        event.preventDefault();
                        break;
                }
            }
        });

        const hasSelection = function () {
            const documentAny = document as any;

            if (window.getSelection) {
                return window.getSelection().toString() !== "";
            } else if (documentAny.selection && documentAny.selection.type != "Control") {
                return documentAny.selection.createRange().text !== "";
            }
            return false;
        };

        $(element).on("click", function (event) {
            if (hasSelection() && event.target !== $input[0]) {
                return;
            }
            $input.focus();
        });

        $output.append("-- Welcome to FlowHtml CLI --");

        ko.applyBindings(commandViewModel, $terminal[0]);

        $input.focus();

        terminalHandle({
            focus: function () {
                $input.focus();
            },
            blur: function () {
                $input.blur();
            }
        });

        commander.exitFunction(function () {
            $input.blur();
            dashViewModel.leaveTerminal();
        });

        commander.hideFunction(function () {
            dashViewModel.hide();
        });

        commander.showFunction(function () {
            dashViewModel.show();
            delayedResize();
        });

        return { controlsDescendantBindings: true };
    }
});
